export type IFormLeadStatus = 'Sem Contato' | 'Qualificado' | 'Desqualificado'

export interface IFormLead {
  id: number
  name: string
  email: string
  phone: string
  format: string
  area: string
  course: string
  source: string
  seller_name: string
  status: IFormLeadStatus
  utm_campaign: string
  utm_source: string
  utm_medium: string
  utm_content: string
  utm_term: string
  created_at: string
}

export const statusTranslations: Record<IFormLeadStatus, string> = {
  'Sem Contato': 'Sem Contato',
  Qualificado: 'Qualificado',
  Desqualificado: 'Desqualificado'
}

/** Mesma ordem do funil, usada no filtro da listagem. */
export const statusOptions = (Object.keys(statusTranslations) as IFormLeadStatus[]).map((status) => ({
  value: status,
  label: statusTranslations[status]
}))

export const statusColors: Record<IFormLeadStatus, string> = {
  'Sem Contato': 'yellow',
  Qualificado: 'green',
  Desqualificado: 'red'
}

export const eventFormat = 'Evento'

export const formatOptions: { value: string; label: string }[] = [
  { value: 'Online', label: 'Online' },
  { value: 'Online Ao Vivo', label: 'Online Ao Vivo' },
  { value: 'Presencial', label: 'Presencial' },
  { value: eventFormat, label: 'Eventos' }
]

export const isEventLead = (format: string) => format.trim().toLowerCase() === eventFormat.toLowerCase()

export type IManualLeadFormat = 'in_person' | 'live_online' | 'recorded'

/**
 * Formatos do registro manual, com os mesmos rótulos do formulário antigo do site. Aqui vão as
 * chaves que a API recebe; o `formatOptions` acima são os rótulos gravados no lead
 * ("Presencial", "Online Ao Vivo"...), usados no filtro da listagem.
 */
export const manualFormatOptions: { value: IManualLeadFormat; label: string }[] = [
  { value: 'in_person', label: 'Presencial' },
  { value: 'live_online', label: 'Online ao Vivo' },
  { value: 'recorded', label: 'Online (videoaulas)' }
]

export interface IFormLeadCreatePayload {
  student_name: string
  name: string
  email: string
  phone: string
  format: IManualLeadFormat
  knowledge_area_id: number
  course_id: number
  source: string
  commercial_consultant_id: number
}

export interface ILeadConsultant {
  id: number
  name: string
}
